<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <h3 class="mb-2">Parcelas de Entrada</h3>
                                <small class="text-muted">Parcelas de entrada do contrato</small>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="lista.length" class="table-responsive">
                            <b-table
                                id="parcelas-entrada"
                                :fields="colunas"
                                :items="lista"
                                :per-page="porPagina"
                                sticky-header
                                head-variant="dark"
                                striped
                                hover
                                @sort-changed="definirOrdem"
                                :sort-by="ordem"
                                :sort-desc="tp_ordem"
                                style="max-height: 600px"
                                :tbody-tr-class="obterClassePorStatus"
                            >
                                <template #cell(valor)="{ item }">
                                    {{ formatarDinheiro(item.valor) }}
                                </template>
                                <template #cell(vl_pago)="{ item }">
                                    {{ item.vl_pago != null ? formatarDinheiro(item.vl_pago) : '-' }}
                                </template>
                                <template #cell(dt_vencimento)="{ item }">
                                    {{ converterDataUsParaBr(item.dt_vencimento) }}
                                </template>
                                <template #cell(dt_pagamento)="{ item }">
                                    {{ item.dt_pagamento ? converterDataUsParaBr(item.dt_pagamento) : '-' }}
                                </template>
                                <template #cell(status_descricao)="{ item }">
                                    <span class="badge badge-default">{{ item.status_descricao }}</span>
                                </template>
                                <template #cell(link_boleto)="{ item }">
                                    <template v-if="item.link_boleto && item.status !== 'CANCELADO'">
                                        <a target="_blank" :href="item.link_boleto" class="btn btn-info btn-outline text-white" v-b-tooltip.hover title="Link Boleto">
                                            <b-icon-file-earmark-arrow-down font-scale="2"></b-icon-file-earmark-arrow-down>
                                        </a>
                                    </template>
                                </template>
                            </b-table>
                        </div>
                        <div v-else>
                            <p>Nenhuma parcela de entrada encontrada.</p>
                        </div>
                    </div>
                    <div class="card-footer" v-if="lista.length">
                        <div class="row">
                            <div class="col-12">
                                <b-pagination
                                    v-model="paginaAtual"
                                    :total-rows="total"
                                    :per-page="porPagina"
                                    aria-controls="parcelas-entrada"
                                    @change="obterLista"
                                ></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import api from '@/api/app.api.js';
import Util from '@/util.js';

export default {
    props: {
        fichaId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            colunas: [
                { key: 'nu_parcela', label: 'Parcela', sortable: true },
                { key: 'valor', label: 'Valor', sortable: true },
                { key: 'vl_pago', label: 'Valor Pago', sortable: true },
                { key: 'dt_vencimento', label: 'Data de Vencimento', sortable: true },
                { key: 'dt_pagamento', label: 'Data de Pagamento', sortable: true },
                { key: 'status_descricao', label: 'Status', sortable: true },
                { key: 'link_boleto', label: 'Link do Boleto', sortable: false }
            ],
            lista: [],
            paginaAtual: 1,
            total: 0,
            porPagina: 10,
            ordem: 'nu_parcela',
            tp_ordem: false
        };
    },
    mounted() {
        this.obterLista(1);
    },
    methods: {
        ...mapActions('msgErro', { exibirMsgErro: 'exibirMsgErro' }),
        formatarDinheiro(valor) {
            return Util.formatarDinheiro(valor);
        },
        converterDataUsParaBr(valor) {
            return Util.converterDataUsParaBr(valor);
        },
        definirOrdem(e) {
            this.ordem = e.sortBy;
            this.tp_ordem = e.sortDesc;
            this.obterLista(1);
            this.paginaAtual = 1;
        },
        obterLista(pagina) {
            const p = (pagina !== undefined ? pagina : this.paginaAtual) - 1;
            const dados = {
                fichaId: this.fichaId,
                offset: p < 0 ? 0 : p,
                limit: this.porPagina,
                ordem: this.ordem,
                tp_ordem: this.tp_ordem ? 'DESC' : 'ASC'
            };
            api.listarParcelasEntrada(dados)
                .then(res => {
                    this.lista = (res.data && res.data.data) ? res.data.data : [];
                    this.total = (res.data && res.data.total) ? res.data.total : 0;
                    this.paginaAtual = p + 1;
                })
                .catch(() => this.exibirMsgErro());
        },
        obterClassePorStatus(item, type) {
            if (!item || type !== 'row') return '';
            if (item.status === 'ABERTO') return 'bg-warning';
            if (item.status === 'PAGO') return 'bg-success';
            if (item.status === 'CANCELADO') return 'bg-danger';
            return '';
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/Contrato/Components/Financiamento/ParcelasEntrada.vue